import { v4 as uuidv4 } from 'uuid';

/**
 * Marks a sub-page id the client minted for a page that exists ONLY in an unsaved editor draft.
 *
 * `CollectionSubPageInput.collectionId` is required and non-nullable, so a not-yet-created page still
 * needs SOME id to be an entry in the draft's `subPages` — to be a React key, a dnd-kit sortable id,
 * and the editor's active-page pointer. Prefixing makes "not real yet" a property of the id itself,
 * which is what lets every page-scoped server read/write recognise an unfetchable page without being
 * told which surface it is on or consulting a parallel "is this saved" flag.
 */
const PENDING_SUB_PAGE_ID_PREFIX = 'pending:';

/**
 * A fresh pending id. Generated ONCE, at add time, and stored in the draft: regenerating it per
 * render would break the sortable identity and the `collection:{id}` row key mid-interaction.
 */
export const createPendingSubPageId = (): string => `${PENDING_SUB_PAGE_ID_PREFIX}${uuidv4()}`;

/** True for an id no server knows about — the page is still only a draft edit. */
export const isPendingSubPageId = (id: string): boolean => id.startsWith(PENDING_SUB_PAGE_ID_PREFIX);
